export default "__VITE_ASSET__J$Nmb$Qj__"